document.addEventListener("DOMContentLoaded", function() {
	$( ".table" ).wrap('<div class="table-responsive"></div>');
});